const BlockView = require('views/block/base-block-view');
const AhoyService = require('services/ahoy-service');
const LocaleService = require('services/locale-service');
import IconLoadService from 'services/icon-load-service';

// # SlickCarouselView
//
// A Page View which will create a JQuery-based 'slick' carousel based on http://kenwheeler.github.io/slick/.
var SlickCarouselView = BlockView.extend({
  load: function() {
    this.cid = this.model.get('cid');
    // completion tracking array
    this.numSlides = this.model.get('slides').length;
    this.completionRequirement = (this.model.get('completion') ? this.model.get('completion') : this.numSlides); // defaults to requiring "all" slides
    if(this.completionRequirement > this.numSlides) {
      // Ensure that completion is possible even if the requirement is set too high
      this.completionRequirement = this.numSlides;
    }
    this.completionArray = new Array(this.completionRequirement).fill(0);
    this.completionArray[0] = 1;
    this.completed = false;
    // child blocks
    this.renderMultipleNestedBlocks('slides');
    // buttons label
    const previousText = LocaleService.t('carousel.previous');
    const nextText = LocaleService.t('carousel.next');
    // init carousel (with useful defaults)
    let defaults = {
      accessibility: true,
      slidesToShow: 1,
      infinite: false,
      arrows: true,
      dots: true,
      respondTo: 'min',
      focusOnChange: true,
      rtl: false,
      prevArrow: `<button class="slick-prev" aria-label="${previousText}" type="button"><i data-icon="${this.cid + '-fas fa-chevron-circle-left'}"></i> <span class="slick-arrow-label">${previousText}</span></button>`,
      nextArrow: `<button class="slick-next" aria-label="${nextText}" type="button"><i data-icon="${this.cid + '-fas fa-chevron-circle-right'}"></i> <span class="slick-arrow-label">${nextText}</span></button>`
    };
    const myconfigs = Object.assign({}, defaults, this.model.get('configs'));
    this.trackcompletion = this.model.get('trackcompletion');
    this.slickcarouselid = '#slickcarousel-' + this.cid;
    this.slickcarousel = $(this.slickcarouselid);

    Chaplin.mediator.subscribe('tab:change', () => {
      this.slickcarousel.slick('setPosition');
    });
    Chaplin.mediator.subscribe('page:state:loaded', () => {
      this.slickcarousel.slick('setPosition');
    });
    this.slickcarousel.on('init reInit', ((event, slick) => {
      this.applyAccessibility(slick);
    }));
    IconLoadService.applyIcon('fa-chevron-circle-right', this.cid, 'fa-2x' || this.model.get('custom_classes'), 'fas');
    IconLoadService.applyIcon('fa-chevron-circle-left', this.cid, 'fa-2x' || this.model.get('custom_classes'), 'fas');
    this.slickcarousel = this.slickcarousel.slick(myconfigs);
  },
  checkComplete: function(slideNum) {
    this.completionArray[slideNum] = 1;
    for(var i = 0; i < this.completionArray.length; i++) {
      if(this.completionArray[i] < 1) {
        return false;
      }
    }
    this.completed = true;
    AhoyService.track('carousel', { action: 'completed' });
    this.readyToGo();
  },
  play: function() {

    this.visibleSlides = this.slickcarousel.slick('slickGetOption', 'slidesToShow');
    if(this.visibleSlides >= this.completionRequirement) {
      // handle the case where all slides are visible at once
      this.completed = true;
      this.readyToGo();
    }
    // track interactive completion
    this.slickcarousel.on('afterChange', ((event, slick, currentSlide) => {
      AhoyService.track('carousel', { action: 'change', currentSlide: currentSlide });
      this.visibleSlides = this.slickcarousel.slick('slickGetOption', 'slidesToShow');
      for(var i = 0; i < this.visibleSlides; i++) {
        // handle the case where more than one slide is visible at a time
        if(!this.completed) {
          this.checkComplete(currentSlide + i);
        }
      }
      this.applyAccessibility(slick);
    }));
  },
  applyAccessibility: function(slick) {
    // executing after 'timeout:0' so as to put it in execution queue and making sure it get's executed after slick.js
    // 'initADA' when slicks 'afterChange' and 'init' event got fire
    setTimeout(() => {
      this.slickcarousel.find(`.${slick.options.dotsClass} li`).each(function(i) {
        const numDotGroups = Math.ceil(slick.$slides.length / slick.options.slidesToShow);
        const attrs = {
          'aria-label': `${LocaleService.t('carousel.slickDotAriaLabel')} ${(i + 1)} of ${numDotGroups}`,
          'tabindex': '-1'
        };
        const $this = $(this);
        const button = $this.find('button');
        $this.find('.slick-slide .card .description').attr(attrs);
        if($this.hasClass('slick-active')) {
          attrs['aria-current'] = true;
          button.removeAttr('aria-selected');
        } else {
          button.removeAttr('aria-current');
        }
        button.attr(attrs);
      });
      const currentSlide = document.querySelector('.slick-current');
      currentSlide && currentSlide.setAttribute('aria-hidden', 'false');
      if (this.slickcarousel.slick('slickGetOption', 'centerMode')) {
        const currentIndex = this.slickcarousel.slick('slickCurrentSlide');
        const actualSlide = this.slickcarousel.find(`[data-slick-index="${currentIndex}"]`);
        actualSlide.find('a, button, input, select').attr('tabindex', 0);
      }
    }, 0);
  }
});

module.exports = SlickCarouselView;
